class CompteRebours {
	constructor() {
		this.firstTimeAnimation = false;
		this.cible = document.getElementById("cibleCompteRebours");
		this.items = document.querySelectorAll(".compteRebours__item");
		this.jour = document.getElementById("cr-jour");
		this.heure = document.getElementById("cr-heure");
		this.minute = document.getElementById("cr-minute");
		this.seconde = document.getElementById("cr-seconde");

		if (!this.cible) {
			return;
		}

		this.init();
	}

	init() {
		setInterval(() => {
			this.compteRebours();
		}, 1000);

		//Watch si le bloc est dans le viewport ou non
		var observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					this.showBlocs();
					observer.unobserve(entry.target);
				}
			});
		});
		observer.observe(this.cible);
	}

	showBlocs() {
		this.items.forEach(_el => _el.classList.add("fadeInBottomSmall"));
	}

	compteRebours() {
		var sec = this.cible.getAttribute("data-sec");
		var min = this.cible.getAttribute("data-min");
		var heure = this.cible.getAttribute("data-heure");
		var jour = this.cible.getAttribute("data-jour");
		var mois = this.cible.getAttribute("data-mois");
		var annee = this.cible.getAttribute("data-annee");

		var date_actuelle = new Date(); // On declare la date d'aujourd'hui.
		// month are 0 based in js, we need to remove 1 month...
		// ref : https://www.w3schools.com/js/js_dates.asp
		var date_butoire = new Date(annee, mois - 1, jour, heure, min, sec);

		var tps_restant = date_butoire.getTime() - date_actuelle.getTime(); // Temps restant en millisecondes

		/*** CONVERSIONS ***/

		var s_restantes = tps_restant / 1000; // On convertit en secondes
		var i_restantes = s_restantes / 60;
		var H_restantes = i_restantes / 60;
		var d_restants = H_restantes / 24;

		s_restantes = Math.floor(s_restantes % 60); // Secondes restantes
		i_restantes = Math.floor(i_restantes % 60); // Minutes restantes
		H_restantes = Math.floor(H_restantes % 24); // Heures restantes
		d_restants = Math.floor(d_restants); // Jours restants

		/***/

		this.jour.innerHTML = this.addZero(d_restants);
		this.heure.innerHTML = this.addZero(H_restantes);
		this.minute.innerHTML = this.addZero(i_restantes);
		this.seconde.innerHTML = this.addZero(s_restantes);
	}

	addZero(element) {
		if (element < 10) {
			element = "0" + element;
		}
		return element;
	}
}
